import {Bot} from "./bot";
import {Determinant} from "./determinant";
import { Role } from "./role";

export class BotDeterminant extends Determinant {

  public determinantType = "BOT";
  public botRoles: Role[];
  public serviceId: string;
  public valid: boolean = true;
  public bot_service_id: string;
  public bots: Bot[];

}
